import React, {useEffect, useCallback, useState} from "react";
import {getBetterCryptoSuggestion, getTop7DayPerformerGainerLooserAPI} from "../../../apihelper/profile";
import {Skeleton, useMediaQuery} from "@mui/material";
import json2mq from "json2mq";
import {useNavigate} from "react-router-dom";
import TableHook from "../../account/profile/tables/TableHook";
import TableCardHook from "../../account/profile/tables/TableCardHook";
import {VolunteerActivismOutlined} from "@mui/icons-material";
import {getPortfolioData} from "../../../apihelper/portfolio";

export const UnderperformerCurrently = (props = {}) => {
    const {cryptoList, portfolioId, my_portfolio} = props;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [loading, setLoading] = useState(false);
    const [my7DaysPortfolio, setMy7DaysPortfolio] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    // const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const [selectedCrypto, setSelectedCrypto] = useState();
    const [portfolio_id, setPortfolio_id] = useState();
    useEffect(() => {
        setPortfolio_id(portfolioId);
    }, [portfolioId]);

    const fetchPortfolioCrypto = useCallback(() => {
        if (!userData || !portfolio_id) {
            return;
        }
        setLoading(true);
        const data = {
            portfolio_type_id: portfolio_id,
            user_id: userData.user_id,
            Token: userData.token,
        };
        console.log("Calling api");
        getPortfolioData(data)
        .then((res) => {
            const slugArray = res.data.map((item) => item.slug);
            console.log("slugArray", res.data);
            setSelectedCrypto(slugArray);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        if (userData || portfolio_id) {
            fetchPortfolioCrypto();
        }
    }, [fetchPortfolioCrypto]);

    const fetchData = useCallback(() => {
        console.log("selectedCrypto", selectedCrypto);
        if (!portfolio_id) {
            return;
        }
        setLoading(true);
        const limit = 1;
        getBetterCryptoSuggestion(selectedCrypto, portfolio_id, limit, userData)
        .then((res) => {
            setMy7DaysPortfolio(res);
            setLoading(false);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const tabData = my7DaysPortfolio?.map((portfolio) => [
        <div className="d-flex ">
            <div className="table-col-1 d-flex gap-3" key={portfolio.coin_name}>
                <img
                    src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${portfolio["crypto_cmc_id"]}.png`}
                    className="crypto_icon"
                    alt={portfolio["symbol"]}
                />
                <span className="tab-text">{portfolio["symbol"]}</span>
            </div>
            <span
                style={{boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
                className="ms-4 text-primary border border-primary rounded-pill bg-white text-sm my-auto px-2 py-1 fs-6"
            >
                {portfolio.category}
            </span>
        </div>,
        portfolio.sevend_change != null && !isNaN(Number(portfolio.sevend_change)) ? (
            <span>
                {Number.isInteger(Number(portfolio.sevend_change))
                    ? `${Number(portfolio.sevend_change)}%`
                    : `${Number(portfolio.sevend_change).toFixed(1)}%`}
            </span>
        ) : (
            "-"
        ),

        <div className="table-col-1 d-flex gap-3" key={portfolio.coin_name}>
            <img
                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${portfolio.better_crypto[0].crypto_cmc_id}.png`}
                className="crypto_icon"
                alt={portfolio.better_crypto[0].slug}
            />
            <span className="tab-text">{portfolio.better_crypto[0].slug}</span>
        </div>,
        portfolio.better_crypto[0].avg_performance != null &&
        !isNaN(Number(portfolio.better_crypto[0].avg_performance)) ? (
            <span>
                {Number.isInteger(Number(portfolio.better_crypto[0].avg_performance))
                    ? `${Number(portfolio.better_crypto[0].avg_performance)}%`
                    : `${Number(portfolio.better_crypto[0].avg_performance).toFixed(1)}%`}
            </span>
        ) : (
            "-"
        ),
    ]);

    const tableHeader = [
        {label: "Crypto", key: "crypto", sorting: true},
        {label: "Last 7 Days", key: "seven_day", sorting: true},
        {label: "Best Performer In Category ", key: "crypto", sorting: true},
        {label: "Last 7 Days", key: "seven_day", sorting: true},
    ];

    return (
        <div className="section-2">
            <TableHook header={tableHeader} tableData={tabData} loading={loading} />

            {/* for mobile */}
            {my7DaysPortfolio.map((portfolio) => (
                <div className="is-mobile">
                    <div
                        className="sm-table-card"
                        style={{
                            background:
                                "linear-gradient(89.97deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0) 123.27%)",
                        }}
                    >
                        <div className="sm-table-heading">
                            <div className="d-flex ">
                                <h6>
                                    <img
                                        alt="image"
                                        src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${portfolio.crypto_cmc_id}.png`}
                                        className="me-2 analysis-icon"
                                        style={{width: 30, height: 30, borderRadius: 19}}
                                    />
                                    {portfolio.symbol}
                                    <span
                                        style={{boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}}
                                        className="ms-4 text-primary border border-primary rounded-pill bg-white text-sm m-auto px-2 py-1 fs-6"
                                    >
                                        {portfolio.category}
                                    </span>
                                </h6>
                            </div>
                        </div>
                        <div className="sm-table-body-custom">
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b>Last 7 Days:</b>
                                <span className="ms-1">
                                    {portfolio.sevend_change != null && !isNaN(Number(portfolio.sevend_change))
                                        ? Number.isInteger(Number(portfolio.sevend_change))
                                            ? `${Number(portfolio.sevend_change)}%`
                                            : `${Number(portfolio.sevend_change).toFixed(1)}%`
                                        : "-"}
                                </span>
                            </span>
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b className="my-auto">Best Performer In the Category:</b>
                                <span
                                    className="ms-1 my-auto"
                                    style={{
                                        border: "1px solid rgba(24, 119, 242, 1)",
                                        borderRadius: "2rem",
                                        fontWeight: "700",
                                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        padding: "4px 10px",
                                        background: "white",
                                        minWidth: "none",
                                        display: "flex",
                                    }}
                                >
                                    <img
                                        src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${portfolio.better_crypto[0].crypto_cmc_id}.png`}
                                        className="crypto_icon"
                                        alt={portfolio.better_crypto[0].slug}
                                    />
                                    <span className="tab-text ms-2">{portfolio.better_crypto[0].slug}</span>
                                </span>
                            </span>
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b>Last 7 Days:</b>
                                <span className="ms-1">
                                    {portfolio.better_crypto[0].avg_performance != null &&
                                    !isNaN(Number(portfolio.better_crypto[0].avg_performance))
                                        ? Number.isInteger(Number(portfolio.better_crypto[0].avg_performance))
                                            ? `${Number(portfolio.better_crypto[0].avg_performance)}%`
                                            : `${Number(portfolio.better_crypto[0].avg_performance).toFixed(1)}%`
                                        : "-"}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            ))}
            {loading &&
                Array.from({length: 3}).map((_, index) => (
                    <TableCardHook
                        key={index}
                        header={{
                            name: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            icon: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} width={40} />,
                        }}
                        body={[
                            {key: "Price", value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />},
                            {
                                key: "Last 7 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                        ]}
                        footer={[{label: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />}]}
                        loading={loading}
                    />
                ))}

            {my7DaysPortfolio.length === 0 && !loading && (
                <div className="add-crypto-watchlist-button d-flex justify-content-center mt-3">
                    {my_portfolio ? (
                        <button
                            className="d-flex align-items-center "
                            onClick={() => {
                                navigate(`/crypto-screener`);
                            }}
                        >
                            <span>ADD MORE CRYPTOS</span>
                            <img
                                src="images/profile_image/account_image/left-arrow-icon.svg"
                                className="left-arrow-icon"
                            />
                        </button>
                    ) : (
                        <button
                            className="d-flex align-items-center "
                            onClick={() => {
                                navigate(`/crypto-screener`);
                            }}
                        >
                            <span>There are no Underperformers at the moment</span>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
